import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const GENERATED_NODE_TEMPLATES_QUERY_KEY = 'autoscaler-generated-templates';

export const getGeneratedTemplatesQueryKey = (clusterId: string) =>
  [GENERATED_NODE_TEMPLATES_QUERY_KEY, clusterId] as const;

const getGeneratedTemplatesQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getGeneratedTemplatesQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.autoscaler.generateNodeTemplates({
        clusterId,
      });
      return data.items || [];
    },
    enabled: enabled && !!clusterId,
  });

type UseGeneratedTemplatesQueryProps = {
  clusterId: string;
  enabled?: boolean;
};

export const useGeneratedTemplatesQuery = ({
  clusterId,
  enabled = true,
}: UseGeneratedTemplatesQueryProps) => {
  const {
    isLoading,
    data: generationTemplates,
    error,
    refetch,
  } = useQuery(getGeneratedTemplatesQueryOptions({ clusterId, enabled }));

  return {
    isLoading,
    generationTemplates,
    error,
    refetch,
  };
};
